import React from "react";
import { useDispatch } from "react-redux";
import { LogoutUser } from "../../../utils/Apis";

const LogoutButton = () => {
  const dispatch = useDispatch();

  const handleLogout = async () => {
    try {
      const resultAction = await dispatch(LogoutUser());

      // Check if the logout action was rejected
      if (LogoutUser.rejected.match(resultAction)) {
        console.error(
          "Logout failed:",
          resultAction.payload || resultAction.error.message
        );
        alert(resultAction.payload || "Logout failed. Please try again.");
      } else {
        alert("Logout successful!");
      }
    } catch (error) {
      console.error("Unexpected error during logout:", error.message);
      alert("Unexpected error occurred during logout. Please try again.");
    }
  };

  return <button onClick={handleLogout}>Logout</button>;
};

export default LogoutButton;
